<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Multiselect,
  },
  props: {
    fieldId: {
      type: String,
      default: '',
      required: false,
    },
    options: {
      type: Array,
      default: Array,
    },
  },
  data: function() {
    return {
      totoalCount: 0,
    }
  },
  computed: {
    recCount() {
      return this.options.length
    },
  },
  methods: {
    customLabel(option) {
      return `${option.text} - ${option.id}`
    },
    onSelect(option) {
      let index = this.options.findIndex((item) => item.text === option.text)
      this.options[index].checked = true
    },

    onRemove(option) {
      let index = this.options.findIndex((item) => item.text === option.text)
      this.options[index].checked = false
    },
  },
}
</script>

<template>
  <div>
    <Multiselect
      tag-placeholder=""
      :options="options"
      select-label=""
      deselect-label=""
      :show-labels="false"
      :searchable="true"
      :close-on-select="false"
      :clear-on-select="false"
      :preserve-search="false"
      placeholder="Select"
      v-bind="$attrs"
      class="multiselecttagg"
      :class="$style.multiselect"
      :taggable="true"
      v-on="$listeners"
      @input="$emit('update', $event)"
      @remove="onRemove($event)"
    >
      <!-- <template slot="tag" slot-scope=""><span /></template> -->
      <!-- <template slot="selection" slot-scope="{ values, search, isOpen }">
        <span v-if="values.length > 0 && !isOpen" class="multiselect__single">
          {{ values.length }} of {{ recCount }} option[s] selected
        </span>
      </template> -->

      <!-- <span
        slot="option"
        slot-scope="scope"
        class="$style.checkbox-label"
        @click.self="select(scope.option)"
      >
        <input
          v-model="scope.option.checked"
          class="test"
          type="checkbox"
          @focus.prevent
        />
        {{ scope.option.text }}
      </span> -->
    </Multiselect>
    <!--
    <Multiselect
      v-model="value"
      tag-placeholder="Add this as new tag"
      placeholder="Search or add a tag"
      label="name"
      track-by="code"
      :options="options"
      :multiple="true"
    ></Multiselect> -->
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" module>
@import '@design';
.multiselect {
  font-size: 12px;
}
.selectbg {
  background-color: $color-button-bg !important;
  border: $input-border;
}
.multiCheckPos {
  position: absolute;
  right: 1vw;
}

.test {
  position: absolute;
  right: 1vw;
}
</style>
